import { Box, TextField } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { CustomPaper } from '../../../../../components/CustomPaper'
import BaseInput from '../../../../../components/dinamicForm/baseInput'
import { Step1StoreProps } from '../types'
import { useStyles } from '../styles'

function Step1Store({ planInfo, data, onChange, errors }: Step1StoreProps) {
  const { t } = useTranslation()
  const styles = useStyles()

  return (
    <Box>
      <CustomPaper sx={styles.cardContainer} elevation={2}>
        <BaseInput
          name='title'
          value={{
            title: {
              label: t('actionPlan.actionPlanTitle'),
              value: data.title,
            },
          }}
          onChange={({ target }) => {
            onChange({ title: target.value as string })
          }}
          errors={errors}
          required
        />
        <Box sx={{ marginTop: '16px', paddingTop: '12px', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
          <TextField
            multiline
            minRows={4}
            maxRows={15}
            label={t('actionPlan.instruction')}
            value={data.description}
            onChange={(e) => onChange({ description: e.target.value })}
            error={!!errors.description}
            helperText={errors.description}
            sx={{
              '& .MuiInputBase-root': {
                alignItems: 'flex-start',
              },
            }}
          />
        </Box>
      </CustomPaper>
    </Box>
  )
}

export default Step1Store
